// @ts-nocheck
import dom from "../../dom2.js";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const dontTreeShakeDom = dom;
import classnames from "classnames";

/**
 * @param {Object}   props
 * @param {function} props.onClickProject
 * @param {boolean}  props.isSelected
 * @param {Object}   props.project
 * @return {HTMLElement}
 */
const ProjectButton = props => {
	const projectUuid = props.project.uuid;

	return (
		<li
			className={classnames("project-item", {
				selected: props.isSelected
			})}
		>
			<button
				className="btn-project js-btn-project"
				data-tippy-content={props.project.name}
				data-uuid={projectUuid}
				onClick={() => props.onClickProject(projectUuid)}
				type="button"
			>
				<span className="project-text">{props.project.name}</span>
			</button>
		</li>
	);
};

export default ProjectButton;
